import { Field, Input, Select, useConfirmationDialog, useUpdateEffect } from '@lbcamden/lib-react';
import { DateTime } from 'luxon';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { useReferenceListSelectOptions, useUserStore } from '~/client/hooks/storeHooks';
import { toPropertyPage } from '~/client/utils/navigation';
import { Person } from '~/common/types/people';

export const useEndHouseholdMemberDialog = (person?: Person) => {
  const navigate = useNavigate();

  const userStore = useUserStore();
  const refListSelectOptions = useReferenceListSelectOptions();

  const [endReason, setEndReason] = useState<string>();
  const [endDate, setEndDate] = useState(DateTime.now().toISODate());

  const canEnd = !!endReason;

  const handleEnd = () => {
    if (!person || !canEnd) {
      return;
    }
    userStore?.handleAndDispatchMessage('endHouseholdMember', person.personId, {
      propertyId: person.propertyId,
      personId: person.personId,
      householdId: person.householdId,
      householdPersonId: person.householdPersonId,
      endDate: endDate || undefined,
      endReason,
    });
    void navigate(toPropertyPage(person.propertyId));
  };

  const { visible, show, confirmationDialog } = useConfirmationDialog({
    title: `End household member: ${person?.fullName})`,
    message: 'Please select a reason below.',
    children: (
      <>
        <Field label="Reason" labelFor="endReason">
          <Select
            id="endReason"
            options={refListSelectOptions('HLD_END')}
            value={endReason}
            onChange={setEndReason}
          />
        </Field>
        <Field label="End date" labelFor="endDate">
          <Input
            id="endDate"
            type="Date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </Field>
      </>
    ),
    confirmButtonProps: { disabled: !canEnd },
    onConfirm: handleEnd,
  });

  useUpdateEffect(() => {
    if (!visible) {
      setEndReason(undefined);
      setEndDate(DateTime.now().toISODate());
    }
  }, [visible]);

  return { showEndMemberDialog: show, endMemberDialog: confirmationDialog };
};
